import { combineReducers } from 'redux';

import account from 'js/src/data/account';
import brandKits from 'js/src/data/brand-kits';
import fonts from 'js/src/data/fonts';
import templates from 'js/src/data/templates';

/**
 * Reducers for the public /themes/ showcase page.
 *
 * Only `templates` is the page's own data. The other three are here because shared
 * components call selectors against them unconditionally - useSelector can't be put behind
 * a variant check - so the slice has to exist even where this page ignores the value:
 * `account` and `brandKits` for the team-settings and brand-kit selectors at the top of
 * TemplatePreviewModal, `fonts` for getFontList in TemplateScenePreviews.
 */
export const getRootReducer = () => {
    return combineReducers({
        account,
        brandKits,
        fonts,
        templates,
    });
};
